(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mobx"), require("React"), require("SBTech"), require("ReactDOM"), require("mobxUtils"));
	else if(typeof define === 'function' && define.amd)
		define("sbRespLib", ["mobx", "React", "SBTech", "ReactDOM", "mobxUtils"], factory);
	else if(typeof exports === 'object')
		exports["sbRespLib"] = factory(require("mobx"), require("React"), require("SBTech"), require("ReactDOM"), require("mobxUtils"));
	else
		root["sbRespLib"] = factory(root["mobx"], root["React"], root["SBTech"], root["ReactDOM"], root["mobxUtils"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__7__) {
return 